import { gql } from '@apollo/client';

export const GET_GRAPHS_LIST = gql`
  query Graphs($params: FindGraphListInput!) {
    graphs(params: $params) {
      success
      message
      errors
      data {
        graphs {
          id
          nodes
          tables
          baseTable
          joinCondition
          businessRules
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_GRAPH = gql`
  query Graph($params: FindGraphInput!) {
    graph(params: $params) {
      success
      message
      errors
      data {
        id
        nodes
        tables
        baseTable
        joinCondition
        businessRules
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
